export type PosthogClient = {
  capture?: (event: string, props?: Record<string, unknown>) => void
  getFeatureFlag?: (key: string) => string | boolean | undefined
  onFeatureFlags?: (callback: () => void) => (() => void) | undefined
}

export function isPosthogDisabled(): boolean {
  const config = useRuntimeConfig()
  return !config.public.POSTHOG_KEY?.trim()
}

export function usePosthogClient(): PosthogClient | undefined {
  if (isPosthogDisabled() || !import.meta.client) {
    return undefined
  }
  const getClient = useNuxtApp().$posthog as (() => PosthogClient | undefined) | undefined
  return getClient?.()
}
